import { Observable } from "rxjs";

/**
 * Repository used to get coach details.
 */
export abstract class CoachRepo {
  abstract getCoachPhoneNumber(
    token: string,
    matchid: string
  ): Observable<string>;
}
